import { init as initSentry, captureException, ErrorBoundary } from "@sentry/react"

import { isServer } from "@p-ban/common/src/utils/CommonUtils"

export const init = () => {
  if (isServer) return
  if (process.env.NEXT_PUBLIC_PBAN_ENV === "development") return

  initSentry({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_PBAN_ENV,
    initialScope: {
      tags: {
        context: "customer",
        program_type: "React",
      },
    },
  })
}

export { captureException, ErrorBoundary }
